import '../css/styles.css'
import { tns } from '../../node_modules/tiny-slider/src/tiny-slider.js'
import feather from 'feather-icons'
import Plyr from 'plyr'

// Open navigation on mobile

const navToggle = document.querySelector('.header__toggle')
const nav = document.querySelector('.header__nav')

navToggle.addEventListener('click', function () {
  const classListAction = nav.classList.contains('header__nav--open') ? 'remove' : 'add'
  nav.classList[classListAction]('header__nav--open')
})

// Initialize Feather Icons

feather.replace()

// Initialize scroll top link

const scrollTopLink = document.querySelector('#scroll-top-link')

scrollTopLink.addEventListener('click', function (e) {
  e.preventDefault()

  window.scroll({
    top: 0,
    behavior: 'smooth'
  })
})

// Initialize logo slider(s)

const logoSliders = document.querySelectorAll('[data-logo-slider]')

if (logoSliders.length >= 1) {
  logoSliders.forEach(function (slider) {
    const slideCount = slider.getAttribute('data-slide-count')
    const mobileSlides = (slideCount < 2) ? slideCount : 2
    const tabletSlides = (slideCount < 3) ? slideCount : 3
    const desktopSlides = (slideCount < 4) ? slideCount : 4

    tns({
      container: slider,
      items: mobileSlides,
      slideBy: 'page',
      controls: false,
      nav: true,
      navPosition: 'bottom',
      useLocalStorage: false,
      responsive: {
        680: {
          items: tabletSlides
        },
        960: {
          items: desktopSlides
        }
      }
    })
  })
}

// Initialize testimonial slider(s)

const testimonialSliders = document.querySelectorAll('[data-testimonial-slider]')

if (testimonialSliders.length > 0) {
  testimonialSliders.forEach(function (slider) {
    tns({
      container: slider,
      items: 1,
      slideBy: 'page',
      controls: false,
      nav: true,
      navPosition: 'bottom',
      autoplay: true,
      autoplayTimeout: 8000,
      speed: 600,
      autoplayButtonOutput: false,
      useLocalStorage: false
    })
  })
}

// Initialize plyr video player

const videoSections = document.querySelectorAll('[data-video-block]')

if (videoSections.length > 0) {
  videoSections.forEach(function (videoSection) {
    const video = videoSection.querySelector('[data-plyr]')

    /* eslint-disable-next-line no-new */
    new Plyr(video, {
      controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'fullscreen'
      ],
      hideControls: true
    })
  })
}

const externalVideoSections = document.querySelectorAll('[data-consent-message]')

if (externalVideoSections.length > 0) {
  externalVideoSections.forEach(function (externalVideoSection) {
    externalVideoSection.querySelector('[data-consent-button]').addEventListener('click', function () {
      const container = externalVideoSection.parentElement
      const video = container.querySelector('[data-plyr-provider]')
      const poster = container.querySelector('[data-plyr-poster]')

      externalVideoSection.classList.add('hidden')
      poster.classList.add('hidden')

      /* eslint-disable-next-line no-new */
      new Plyr(video, {
        controls: [
          'play-large',
          'play',
          'progress',
          'current-time',
          'fullscreen'
        ],
        hideControls: true
      })
    })
  })
}
